import { createContext } from 'react';
import { initialState } from './DiagnosticoReducer';

export const DiagnosticoContext = createContext({ ...initialState });
